module.exports = __webpack_public_path__ + "static/media/not-found.60acd080.svg";